import React, { Component } from "react";
import {Helmet} from 'react-helmet'

class PageHelmet extends Component{
    render(){
        return(
            <React.Fragment>
                <Helmet>
                    <title>Zetto Advertising || {this.props.pageTitle} </title>
                    <meta name="description" content="Zetto Advertising – Putting data to work" />
                </Helmet>
            </React.Fragment>
        )
    }
}


export default PageHelmet;
